var map = {
	"./animales.jpg": "fa29",
	"./cocina.jpg": "edae",
	"./deportes.jpg": "93e5",
	"./funny.jpg": "995e",
	"./lifestyle.jpg": "f5b5",
	"./nuevos.jpg": "1c01",
	"./viral.jpg": "3eac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c849";